// 阿拉伯语
export default {
  /* SOP主播招募 */
  recruitment: {
    lang1: "مساعد مباشر",
    lang2: "إذا كنتَ لاعبًا مقيدًا كمساعد مباشر، فسيحصل اللاعب على حصتك من نقاط FIRE التي حصلتَ عليها.",
    lang3: "مساعد مباشر مقيد",
    lang4: "أدخل المُعرِّف لتأكيد اللاعب المقيد.",
    lang5: "أدخل معرف اللاعب الذي تريد ربطه",
    lang6: "الخطوة التالية",
    lang7: "نسبة حصة FIREs",
    lang8: "تعليمات الربط",
    lang9: "بعد ربط مساعدك المباشر، سيستلم مساعدك المباشر حصة من نقاط FIRE التي تجمعها. سيتم إرسال نقاط FIRE التي تجمعها من خلال الهدايا إلى مساعدك المباشر وفقًا لنسبة حصة نقاط FIRE التي حددتها.",
    lang10: "تم",
    lang11: "ربط مساعدك المباشر",
    lang12: "تأكيد الربط؟",
    lang13: "مساعدك المباشر",
    lang14: "إلغاء",
    lang15: "تم الربط بنجاح",
    lang16: "فشل الربط",
    lang17: "تم فك الارتباط بنجاح",
    lang18: "فشل فك الارتباط",
    lang19: "إذا كنتَ لاعبًا مقيدًا كمساعد مباشر، فسيحصل اللاعب على حصتك من نقاط FIRE التي حصلتَ عليها.",
    lang20: "مساعدي المباشر",
    lang21: "فك الارتباط",
    lang22: "في انتظار التأكيد",
    lang23: "فك ارتباط مساعدك المباشر",
    lang24: "يتطلب فك الارتباط من مساعد مباشر تأكيدًا من الطرف الآخر. هل تريد فك الارتباط؟",
    lang25: "مساعدك المباشر؟",
    lang26: "تم رفض فك الارتباط",
    lang27: "رفض فك الارتباط، فشل",
    lang28: "إعدادات مساعدك المباشر",
    lang29: "\u200f الحصول على FIREs\u200f",
    lang30: "قام الطرف الآخر بفك ارتباطك بمساعدك المباشر؛ يتطلب تأكيدك.",
    lang31: "طلب فك الارتباط",
    lang32: "تم تطبيق العكس على إلغاء ربط حساب مساعدك المباشر. يرجى التأكيد.",
    lang33: "رفض",
    lang34: "قائمة المُذيعين الذين ربطوني كمساعد مباشر",
    lang35: "لم يتم ربط أي لاعبين بعد",
    lang36: "فك ارتباط مساعدك المباشر",
    lang37: "هل تريد فك الارتباط؟",
    lang38: "ما هي علاقتك بمساعد مباشر؟",
    lang39: "لقد تم حظر المستخدم.",
    lang40: "لقد فشل البحث عن المعرف الذي أدخلته.",
  },
};
